import type { Features } from "~/core";

export const isFeatures = (item: unknown): item is Features => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "features"
  );
};
